import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'thema-core-input-error',
  templateUrl: './input-error.component.html',
  styleUrls: ['./input-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputErrorComponent {}
